import { createPinia, defineStore } from 'pinia'

const mainStore = {
	install(vue, parameters) {
	},
  pinia: defineStore
};
export default mainStore;